var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import '@bit/smartworks.unity.unity-core/unity-split-pane';
export default class UnitySplitPane extends Component {
    constructor() {
        super(...arguments);
        this.splitPaneRef = React.createRef();
        this.componentDidMount = () => {
            this.updateProperties();
        };
        this.componentDidUpdate = () => {
            this.updateProperties();
        };
        this.updateProperties = () => {
            const { props, splitPaneRef } = this;
            const unitySplitPane = splitPaneRef.current;
            const { header, main, pane, footer, onClose, onResize, onCollapseChange, show, closeButton, collapseButton, collapsed } = props;
            if (unitySplitPane) {
                unitySplitPane.onClose = onClose || (() => { });
                unitySplitPane.onResize = onResize || (() => { });
                unitySplitPane.onCollapseChange = onCollapseChange || (() => { });
                unitySplitPane.header = header;
                unitySplitPane.main = main;
                unitySplitPane.pane = pane;
                unitySplitPane.footer = footer;
                if (show)
                    unitySplitPane.show = show;
                if (closeButton)
                    unitySplitPane.closeButton = closeButton;
                if (collapseButton)
                    unitySplitPane.collapseButton = collapseButton;
                if (collapsed)
                    unitySplitPane.collapsed = collapsed;
            }
        };
    }
    render() {
        const _a = this.props, { header, main, pane, footer, show, closeButton, collapsed, collapseButton } = _a, otherProps = __rest(_a, ["header", "main", "pane", "footer", "show", "closeButton", "collapsed", "collapseButton"]);
        let splitPaneArgs = Object.assign({}, otherProps);
        if (show)
            splitPaneArgs.show = show;
        if (closeButton)
            splitPaneArgs.closeButton = closeButton;
        if (collapseButton)
            splitPaneArgs.collapseButton = collapseButton;
        if (collapsed)
            splitPaneArgs.collapsed = collapsed;
        return (React.createElement("unity-split-pane", Object.assign({ className: "usp-wrapper", ref: this.splitPaneRef }, splitPaneArgs),
            React.createElement("div", { slot: "header", style: { flex: 1, width: '100%' } }, header),
            React.createElement("div", { slot: "main", style: { height: '100%', display: 'flex', overflow: 'hidden' } }, main),
            React.createElement("div", { slot: "pane", style: { height: '100%', display: 'flex', overflow: 'hidden', zIndex: 3 } }, pane),
            React.createElement("div", { slot: "footer" }, footer)));
    }
}
